import { FormattedMessage } from 'dibs-react-intl';
import { Link } from 'dibs-elements/exports/Link';
import getBuyerSupportLink from 'dibs-support-link/exports/getBuyerSupportLink';

const learnMore = (
    <FormattedMessage id="requestShippingModal.learnMore" defaultMessage="Learn more" />
);

const learnMoreDisclaimer = (
    <FormattedMessage id="requestShippingModal.learnMoreDisclaimer" defaultMessage="Learn more" />
);

export const shippingModal = {
    modalTitle: (
        <FormattedMessage id="requestShippingModal.modal_title" defaultMessage="Shipping Options" />
    ),
    shipTo: <FormattedMessage id="requestShippingModal.ship_to" defaultMessage="Destination" />,
    method: <FormattedMessage id="requestShippingModal.method" defaultMessage="Method" />,
    time: <FormattedMessage id="requestShippingModal.time" defaultMessage="Arrives In" />,
    price: <FormattedMessage id="requestShippingModal.price" defaultMessage="Cost" />,
    linkCta: learnMore,
    shipsFrom: function shipsFrom(address) {
        return (
            <FormattedMessage
                id="requestShippingModal.ships_from"
                defaultMessage="ships from {address}"
                values={{ address }}
            />
        );
    },
    serviceMethod: function serviceMethod(quote) {
        const buyerServiceMethodDisplay = quote.buyerServiceMethodDisplay;
        return (
            <FormattedMessage
                id="requestShippingModal.service_method"
                defaultMessage="{buyerServiceMethodDisplay}"
                values={{ buyerServiceMethodDisplay }}
            />
        );
    },
    servicesIncluded: (
        <FormattedMessage
            id="requestShippingModal.services_included"
            defaultMessage="Services Included"
        />
    ),
    courier: <FormattedMessage id="requestShippingModal.courier" defaultMessage="Courier" />,
    standardExpress: (
        <FormattedMessage
            id="requestShippingModal.standard"
            defaultMessage="Standard and Express"
        />
    ),
    frontDoor: (
        <FormattedMessage id="requestShippingModal.front_door" defaultMessage="Front Door" />
    ),
    inHomeDelivery: (
        <FormattedMessage
            id="requestShippingModal.in_home_delivery"
            defaultMessage="In-Home Delivery"
        />
    ),
    serviceDescription: function serviceDescription(quote) {
        return (
            <FormattedMessage
                id="requestShippingModal.service_description"
                defaultMessage={`{serviceType, select,
                PARCEL {{serviceMethodType, select,
                    MESSENGER {Hand-delivered via a local messenger service at a time that is convenient for you to sign for a delivery.}
                    other {Carefully packaged and delivered via a parcel delivery service such as UPS or FedEx.}
                }}
                FREIGHT {Delivered to front door of your house or building and does not include unpacking, inspection, assembly, or installation.}
                other {Delivered to room of choice and includes unpacking, inspection, and minor assembly at your convenience.}
            } Facilitated by {is1stdibsBilledQuote, select,
                true {1stDibs}
                other {seller}
            }.`}
                values={{
                    serviceType: quote?.serviceMethod?.serviceType,
                    serviceMethodType: quote?.serviceMethod?.serviceMethodType,
                    is1stdibsBilledQuote: quote?.is1stdibsBilledQuote,
                }}
            />
        );
    },
    requestShippingQuoteLink: (
        <FormattedMessage
            id="requestShippingModal.request_shipping_quote_link"
            defaultMessage="Request a quote"
        />
    ),
    requestShippingQuote: linkCta => (
        <FormattedMessage
            id="requestShippingModal.request_shipping_quote_text"
            defaultMessage="Request a shipping quote for a different method: {linkCta}"
            values={{ linkCta }}
        />
    ),
    label: function labelFormatter(label) {
        return (
            <FormattedMessage
                id="requestShippingModal.label"
                defaultMessage="{label}"
                values={{ label }}
            />
        );
    },
    someShippingMethods: (
        <FormattedMessage
            id="requestShippingModal.some_methods"
            defaultMessage="Some shipping methods may only be available upon request."
        />
    ),
    disclaimer: (
        <FormattedMessage
            id="requestShippingModal.disclaimer"
            defaultMessage="Questions about shipping methods? {linkCta}"
            values={{
                linkCta: (
                    <Link
                        href={getBuyerSupportLink('/en-us/articles/14516879314587/')}
                        target="_blank"
                    >
                        {learnMoreDisclaimer}
                    </Link>
                ),
            }}
        />
    ),
    legal: (
        <FormattedMessage
            id="requestShippingModal.legal"
            defaultMessage="Customs duties and taxes may apply to international purchases. {linkCta}"
            values={{
                linkCta: (
                    <Link
                        href={getBuyerSupportLink('/en-us/articles/14491601612827/')}
                        target="_blank"
                    >
                        {learnMore}
                    </Link>
                ),
            }}
        />
    ),
    preDisclaimerNoQuotes: (
        <FormattedMessage
            id="requestShippingModal.pre_disclaimer_no_quotes"
            defaultMessage="Shipping quotes have not been provided for this item."
        />
    ),
    preDisclaimerStandard: (
        <FormattedMessage
            id="requestShippingModal.pre_disclaimer_standard"
            defaultMessage="Shipping somewhere else?"
        />
    ),
    preDisclaimerRequestShippingQuote: (
        <FormattedMessage
            id="requestShippingModal.pre_disclaimer_request_shipping_quote"
            defaultMessage="Need different shipping arrangements?"
        />
    ),
    blockRequest: (
        <FormattedMessage
            id="requestShippingModal.blockRequest"
            defaultMessage="If you need expedited shipping or a different method, contact the seller."
        />
    ),
    localPickupLabelWithAddress: function serviceDescription(address) {
        return (
            <FormattedMessage
                id="requestShippingModal.localPickupLabelWithAddress"
                defaultMessage="Local pickup in {address}"
                values={{ address }}
            />
        );
    },
    localPickupLabel: (
        <FormattedMessage
            id="requestShippingModal.localPickupLabel"
            defaultMessage="Local pickup"
        />
    ),
    buyerArrangedShippingLabel: (
        <FormattedMessage
            id="requestShippingModal.buyerArrangedShippingLabel"
            defaultMessage="Buyer arranged shipping"
        />
    ),
    freeShippingLabel: (
        <FormattedMessage id="requestShippingModal.freeShippingLabel" defaultMessage="Free" />
    ),
    shippingQuoteNotDetermined: linkCta => (
        <FormattedMessage
            id="requestShippingModal.shippingQuoteNotDetermined"
            defaultMessage="A shipping quote to your location could not be determined. {linkCta}"
            values={{ linkCta }}
        />
    ),
};
